export default __webpack_public_path__ + "static/specialist2-min-e328b79430fd4e4dec471acb2c3a4342.png";